// extracted by mini-css-extract-plugin
export var emailBlockLink = "_l7-0";